import { type FC } from 'react';

export interface BreakViewProps {
    breakLabel: React.ReactNode;
}

const BreakView: FC<BreakViewProps> = (props: BreakViewProps) => {
    const { breakLabel = '...' } = props;
    return (
        <div className="pagination-item pagination-item-break">
            <span className="pagination-item-content">{breakLabel}</span>
        </div>
    );
};

export default BreakView;
